import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";

/*
 *  Organization Management Services
 * !== 기관 관리 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/usr/org`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/org-mgmt`,
    nodes: [],
};

export const URLS = {
    ptli0916001q: `${BASE.path}/ptli0916001q`, // Organization List !==  기관 목록 ==!
    ptli0916002s: `${BASE.path}/ptli0916002s`, // Organization Registration !==  기관 등록 ==!
    ptli0916003s: `${BASE.path}/ptli0916003s`, // Modifying and deleting Organization!==  기관 수정 및 삭제 ==!
    ptli0916004q: `${BASE.path}/ptli0916004q`, // Organization Detail !==  기관 상세 ==!
};

// LPCO Issue Yes or Not   !== LPCO  발급 여부 ==!
const lpcoYn = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
];

// Organization, Department Status code  !== 기관,부서 상태코드값 ==!
const orgStatCd = [
    { label: "Active", value: "01" },
    { label: "Suspended", value: "02" },
    { label: "Revoked", value: "03" },
];

const lpcoIssuYnCode = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
]

export const APIS = {
    // Check Organization List !==  기관 목록 조회 ==!
    getOrgList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Check Organization information !==  기관 정보 조회 ==!
    getOrgInfo: (id: any) => {
        return api.get(`${BASE.api}/${id}`);
    },
    // Create Organization information !==  기관 정보 등록 ==!
    createOrgInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },
    // update Organization information !==  기관 정보 수정 ==!
    updateOrgInfo: (data: any) => {
        return api.put(`${BASE.api}/${data.orgCd}`, { ...data });
    },
    //delete Organization information !== 기관 정보 삭제 ==!
    deleteOrgInfo: (orgCd: any) => {
        return api.delete(`${BASE.api}/${orgCd}`);
    },

    // Check Organization Department List !== 기관의 부서 목록 조회 ==!
    getOrgDeptList: (orgCd: any) => {
        return api.get(`${BASE.api}/dept-${orgCd}`);
    },
    // Check Organization Department information !== 기관의 부서 정보 조회 ==!
    getOrgDeptInfo: (orgCd: any, deptCd: any) => {
        return api.get(`${BASE.api}/dept/${orgCd}-${deptCd}`);
    },

    // Create Organization Department information !==  기관의 부서 정보 등록 ==!
    saveOrgDeptInfo: (data: any) => {
        return api.post(`${BASE.api}/dept`, { ...data });
    },

    // delete Organization Department information !== 기관의 부서 정보 삭제 ==!
    deleteOrgDeptInfo: (data: any) => {
        return api.delete(`${BASE.api}/dept/${data.orgCd}-${data.deptCd}`);
    },

    // Get a excel list of OGA Management. !== 기관 관리 엑셀 목록을 조회한다. ==!
    getOrgExcelList: (data: any) => api.get(`${BASE.api}/excel`, { params: comnUtils.toGetParams(data) }),

    // Organization Tin duplicate check !== 기관 TIN 중복 체크 ==!
    getOrgTinDuplCheck: (orgTin: string) => {
        return api.get(`${BASE.api}/getorgTinDuplCheck/${orgTin}`);
    },

    // Organization Tin status check (exists / deleted) !== 기관 TIN 상태 체크 ==!
    getOrgTinDuplAndDelCheck: (orgTin: string) => {
        return api.get(`${BASE.api}/getorgTinDuplAndDelCheck/${orgTin}`);
    },

// Restore a soft-deleted organization !== 삭제된 기관 정보 복원 ==!
    restoreOrgInfo: (orgCd: string) => {
        return api.put(`${BASE.api}/restore/${orgCd}`);
    },
};

export const SF_ORG_MGMT_SRCH: TFormSchema = {
    id: "form_orgSrch",
    schema: {
        orgCd: { type: "code", label: "L_ORG_CD", area: "orgCd", popupSize: "md" },
        orgNm: { type: "text", label: "L_ORG_NM" },
        lpcoIssuYn: {type: "select", label: "LPCO Issuance", options: lpcoIssuYnCode}
    },
};

export const SF_ORG_MGMT_INFO: TFormSchema = {
    id: "form_orgInfo",
    schema: {
        orgCd: { type: "text", label: "L_ORG_CD" },
        orgRegnDvnCd: {
            type: "radio",
            label: "L_ORG_REGN_DVN_CD",
            required: true,
            options: [
                { label: "L_REGN_M_CD", value: "M" },
                { label: "L_REGN_Z_CD", value: "Z" },
            ],
        },
        orgAbrtNm: { type: "text", label: "L_ORG_ABRT_NM" },
        orgNm: { type: "text", label: "L_ORG_NM", required: true, controlSize: 4 },
        tin: { type: "text", label: "L_ORG_TIN", required: true },
        hgovNm: { type: "text", label: "L_ORG_GOV_NM" },
        orgStatCd: { type: "radio", label: "L_ORG_STAT_CD", options: orgStatCd, required: true },
        rprsTelno: { type: "text", label: "L_RPRS_TEL_NO", required: true },
        rprsFaxNo: { type: "text", label: "L_RPRS_FAX_NO" },
        postAddr: { type: "text", label: "L_ORG_PO_ADDR", required: true, controlSize: 10 },
        lpcoIssuYn: { type: "radio", label: "L_LPCO_ISSU_YN", options: lpcoYn, required: true },
        frstRgsrDtm: { type: "text", label: "L_FRST_RGSR_DTM" },
    },
};

export const SF_ORG_DEPT_INFO: TFormSchema = {
    id: "form_deptInfo",
    schema: {
        orgCd: { type: "text", label: "L_ORG_CD" },
        deptCd: { type: "text", label: "L_DEPT_CD" },
        uprDeptCd: { type: "code", label: "L_UPR_DEPT_CD", area: "orgDeptCd", popupSize: "md", controlSize: 10 },
        deptNm: { type: "text", label: "L_DEPT_NM", required: true, controlSize: 10 },
        orgStatCd: { type: "radio", label: "L_ORG_STAT_CD", options: orgStatCd },
        deptDesc: { type: "text", label: "L_DEPT_DESC", controlSize: 10 },
        deptIdtnOrd: { type: "text", label: "L_DEPT_IDTN_ORD", controlSize: 10 },
        useYn: {
            type: "text",
            label: "L_USE_YN",
            options: [
                { label: "Y", value: "Y" },
                { label: "N", value: "N" },
            ],
            controlSize: 10,
        },
    },
};

export const SG_ORG_MGMT_LIST: TGridSchema = {
    id: "grid_orgList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_ORG_CD", binding: "orgCd", width: "10%" }] },
        { cells: [{ header: "L_ORG_NM", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_ORG_GOV_NM", binding: "hgovNm", width: "25%" }] },
        { cells: [{ header: "L_ORG_STAT_CD", binding: "orgStatCdNm", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "orgCd" }],
        },
        {
            cells: [{ binding: "orgNm", align: "left" }],
        },
        {
            cells: [{ binding: "hgovNm", align: "left" }],
        },
        {
            cells: [{ binding: "orgStatCdNm" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
    ],
};

export const SG_ORG_MGMT_EXCEL_LIST: TGridSchema = {
    id: "grid_orgList",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_ORG_CD", binding: "orgCd", width: "10%" }] },
        { cells: [{ header: "L_ORG_NM", binding: "orgNm", width: "*" }] },
        { cells: [{ header: "L_ORG_GOV_NM", binding: "hgovNm", width: "25%" }] },
        { cells: [{ header: "L_ORG_STAT_CD", binding: "orgStatCdNm", width: "10%" }] },
        { cells: [{ header: "L_FRST_RGSR_DTM", binding: "frstRgsrDtm", width: "15%" }] },
    ],
    body: [
        {
            cells: [{ binding: "orgCd" }],
        },
        {
            cells: [{ binding: "orgNm", align: "left" }],
        },
        {
            cells: [{ binding: "hgovNm", align: "left" }],
        },
        {
            cells: [{ binding: "orgStatCdNm" }],
        },
        {
            cells: [{ binding: "frstRgsrDtm", type: "datetime" }],
        },
    ],
};
